<div class="plugin-form">

  <p class="plugin-section-title">Batch Schedule Details</p>

  <form [formGroup]="requisitionForm">
    <ng-container formArrayName="trainingSchedules">
      <div [formGroupName]="0">

        <!-- Batch title -->
        <mat-form-field appearance="outline" class="form-field-full">
          <mat-label>Batch Title</mat-label>
          <input matInput formControlName="title" placeholder="e.g. Morning Batch">
          <mat-error *ngIf="schedules.at(0)?.get('title')?.hasError('required')">Required</mat-error>
        </mat-form-field>

        <!-- Trainer -->
        <mat-form-field appearance="outline" class="form-field-full">
          <mat-label>Trainer</mat-label>
          <mat-select formControlName="trainers">
            <mat-option [value]="''">— None —</mat-option>
            <mat-option *ngFor="let t of trainers" [value]="t.id">{{ t.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Date Ranges -->
        <div class="date-ranges-section">
          <div class="date-ranges-header">
            <span class="field-label">Date Ranges</span>
            <button mat-stroked-button color="primary" type="button" (click)="addDateRange(0)">
              <mat-icon>add</mat-icon> Add Date Range
            </button>
          </div>

          <div formArrayName="dateRanges">
            <div
              *ngFor="let rangeCtrl of getDateRangesArray(0).controls; let j = index"
              [formGroupName]="j"
              class="date-range-block">

              <!-- Row 1: date range picker + delete -->
              <div class="date-range-row">
                <mat-form-field appearance="outline" class="date-range-field">
                  <mat-label>Date Range {{ j + 1 }}</mat-label>
                  <mat-date-range-input [rangePicker]="rangePicker" [min]="minDate">
                    <input matStartDate formControlName="startDate" placeholder="Start">
                    <input matEndDate formControlName="endDate" placeholder="End">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                  <mat-date-range-picker #rangePicker></mat-date-range-picker>
                  <mat-error *ngIf="rangeCtrl.get('startDate')?.hasError('required') || rangeCtrl.get('endDate')?.hasError('required')">
                    Start and end date are required
                  </mat-error>
                </mat-form-field>

                <button mat-icon-button type="button" color="warn"
                  (click)="removeDateRange(0, j)"
                  [disabled]="getDateRangesArray(0).length === 1"
                  title="Remove date range">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>

              <!-- Row 2: time pickers -->
              <div class="time-row">
                <span class="field-label time-from-label">From</span>
                <app-time-picker formControlName="startTime" class="range-time-picker"></app-time-picker>
                <span class="time-separator">—</span>
                <app-time-picker formControlName="endTime" class="range-time-picker"></app-time-picker>
                <mat-error class="time-error"
                  *ngIf="rangeCtrl.get('startTime')?.invalid || rangeCtrl.get('endTime')?.invalid">
                  Both start and end time are required
                </mat-error>
              </div>

            </div>
          </div>
        </div>

      </div>
    </ng-container>
  </form>

</div>

